import axios from "axios";
import { assignTelecallingLeadsApi, calllogsCRUDApi, currentLeadViewApi, followupCRUDApi, leadListGetAdminApi, leadListGetApiApi, leadStatsCombinedApi, leadsCRUDApi, uploadLeadsApi } from "../constants/apis";
import { getUserToken } from "../helpers/local_storage_helpers";

export const getLeads = async (query = '') => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(leadListGetApiApi + "?" + query ?? "", config);
    return response;
};

export const getLeadsAdmin = async (query = '') => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(leadListGetAdminApi + "?" + query ?? "", config);
    return response;
};

export const getLeadStats = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(leadStatsCombinedApi + query, config);
    return response;
};

export const getCurrentOpenLead = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(currentLeadViewApi, config);
    return response;
};

export const getLeadDetails = async (id) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.get(leadsCRUDApi + id + "/followup-details/", config);
    return response;
};

export const updateLead = async (id, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(leadsCRUDApi + id + "/", data, config);
    return response;
};

export const addLead = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(leadsCRUDApi, data, config);
    return response;
};

export const patchLead = async (id, data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(followupCRUDApi + id + "/", data, config);
    return response;
};

export const postCallLog = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(calllogsCRUDApi, data, config);
    return response;
};

export const patchCallLog = async ({ id, data }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.patch(calllogsCRUDApi + id + "/", data, config);
    return response;
};

export const uploadLeads = async (formData) => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Token ${getUserToken()}`,
        },
    };
    const response = await axios.post(uploadLeadsApi, formData, config);
    return response;
};

export const assignTelecallingLeads = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${getUserToken()}`,
        },
    };

    const response = await axios.post(assignTelecallingLeadsApi, data, config);
    return response;
};
